import {
	Action,
	Dispatch,
} from 'redux';
// Import services
import {
	StringService,
} from '@app/services';
// Import action type enumeration.
import ActionType from '@app/redux/actions/types';
import {
	AddressType,
	NotificationType,
	OverlayTarget,
} from '@app/enumerations';
// Import api models.
import {
	Address,
	AddressVerification
} from '@app/models/api';
// Import controller factory.
import ControllerFactoryProvider from '@app/controllers/factory';
// Import action methods.
import {
	addNotification,
	endProcessing,
	startProcessing,
} from '@app/redux/actions/methods';


interface LoadAddressSuggestionParameters {
	address: string;
}

const loadAddressSuggestions = (params: LoadAddressSuggestionParameters) =>
	async (dispatch: Dispatch): Promise<Address[]> => {
		try {
			let addressSuggestions: Address[] = await ControllerFactoryProvider.getControllerFactory().getPropertyController().getAddressSuggestions(params.address);
			return addressSuggestions;
		} catch (error: any) {
			await addNotification({
				title: 'Error',
				primaryMessage: error.message,
				secondaryMessage: error.systemMessage,
				notificationType: NotificationType.ERROR,
			})(dispatch);
			// Throw error.
			throw error;
		}
	};

interface VerifyAddressParameters {
	addressType: AddressType;
	addressLine1: string;
	addressLine2: string;
	city: string;
	state: string;
	postalCode: string;
}

const verifyAddress = (params: VerifyAddressParameters) =>
	async (dispatch: Dispatch): Promise<AddressVerification> => {
		// Generate message id.
		const messageId: string = `${StringService.getInstance().hashObject(undefined)}-addressVerification`;
		let addressType: string = params.addressType.toLowerCase();

		try {
			//Start process.
			await startProcessing({
				message: `Verifying ${addressType}...`,
				messageId: messageId,
				overlayTarget: OverlayTarget.SCREEN,
			})(dispatch);

			let verifiedAddress: AddressVerification = await ControllerFactoryProvider.getControllerFactory().getPropertyController().verifyAddress(params.addressLine1, params.addressLine2, params.city, params.state, params.postalCode);

			// End process.
			await endProcessing({
				messageId: messageId,
				overlayTarget: OverlayTarget.SCREEN
			})(dispatch);

			return verifiedAddress;
		} catch (error: any) {
			await addNotification({
				title: 'Error',
				primaryMessage: error.message,
				secondaryMessage: error.systemMessage,
				notificationType: NotificationType.ERROR,
			})(dispatch);

			// End process.
			await endProcessing({
				messageId: messageId,
				overlayTarget: OverlayTarget.SCREEN
			})(dispatch);
			// Throw error.
			throw error;
        }
	};

// Export actions.
export {

};

// Export action methods.
export {
	loadAddressSuggestions,
	verifyAddress
};

// Export action parameters.
export {
	LoadAddressSuggestionParameters,
	VerifyAddressParameters
};

// Export action factories.
export {

};